import React, { useEffect, useState, useRef } from 'react';
import { Loading } from '../components/loading.js';
import { Turl } from '../components/tUrl.js'
import '../css/trade.css'; // Common styles for info blocks
import { formatNumberWithCommas } from '../components/formatIntegerWithCommas.js'
import { t } from 'ttag';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';

DataTable.use(DT);

const tg = window.Telegram ? window.Telegram.WebApp : null;

function Trade({ recData, handlesetIndex }) {
    const [mData, setmData] = useState(null);
    const hasFetchedData = useRef(false); // Ref для отслеживания первого вызова

    useEffect(() => {
        const getData = async () => {
            hasFetchedData.current = true;

            try {
                const _userData = tg ? tg.initData : null;
                let userData = { initData: _userData }


                if (userData) {
                    const response = await fetch(Turl + '/st/trade', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(userData)
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    let rd = await response.json();
                    for (let index = 0; index < rd.data.orders.length; index++) {
                        const element = rd.data.orders[index];
                        const date = new Date(parseInt(element.dt));
                        const dt = date.toLocaleString();
                        element.dt = ("" + dt).replace(",", "</br>");
                        element.profit = parseFloat(element.profit).toFixed(2)
                        if (element.price > 1000) {
                            element.price = parseFloat(element.price).toFixed(2)
                            element.priceClose = parseFloat(element.priceClose).toFixed(2)
                        } else {
                            element.price = parseFloat(element.price).toFixed(4)
                            element.priceClose = parseFloat(element.priceClose).toFixed(4)
                        }
                    };
                    setmData(rd)
                } else {
                    console.warn("Telegram user data not available.");
                }

            } catch (error) {
                console.error('Authentication error:', error);
            }
        };

        if (!mData && !hasFetchedData.current) {
            getData();
        }
    }, [mData]);

    if (!mData)
        return <Loading />;
    hasFetchedData.current = false;


    // --- Блок Баланса и Кнопок ---
    const bal = (
        <>
            <div className="trade-block t-balance-card">
                <div className="t-balance-label">{t`Trade balance`}</div>
                <div className="t-balance-value">{formatNumberWithCommas(recData.trade_balance, 0)} USDT</div>
            </div>
            <div className="t-button-container">
                <button className="t-action-button" onClick={() => { handlesetIndex(21) }}>
                    {t`Deposit`}
                </button>
                <button className="t-action-button" onClick={() => { handlesetIndex(22) }}>
                    {t`Withdrowal`}
                </button>
            </div>
        </>
    );

    // --- Блок Статистики ---
    const stat = (
        <div className='trade-block'>
            <div className='t-block-title'>Stat</div>
            <div className="t-data-row">
                <div className="t-data-label">Day profit</div>
                <div className="t-data-value">
                    {formatNumberWithCommas(mData.data.profit_day, 5)} USDT
                </div>
            </div>
            <div className="t-data-row">
                <div className="t-data-label">Total profit</div>
                <div className="t-data-value">
                    {formatNumberWithCommas(mData.data.profit_total, 5)} USDT
                </div>
            </div>
            <div className="t-data-row">
                <div className="t-data-label">Usage deposit</div>
                <div className="t-data-value">
                    {parseFloat(mData.data.dep_use).toFixed(2)} %
                </div>
            </div>
        </div>
    );

    // --- Блок Таблицы ---
    const trd = (
        <div className="tTHDataTable">
            <div className="table-responsive">
                <DataTable
                    data={mData.data.orders}
                    className="display dark cell-border compact stripe"
                    options={{
                        searching: false,
                        autoWidth: true,
                        layout: { topStart: null },
                        order: [[1, 'desc']],
                    }}
                    columns={[
                        { data: 'symbol' },
                        { data: 'dt' },
                        { data: 'price' },
                        { data: 'priceClose' },
                        { data: 'profit' },
                    ]}
                >
                    <thead>
                        <tr>
                            <th>{t`symbol`}</th>
                            <th style={{ width: "30%" }}>{t`date`}</th>
                            <th style={{ width: "10%" }}>{t`price`}</th>
                            <th style={{ width: "10%" }}>{t`price close`}</th>
                            <th style={{ width: "10%" }}>{t`profit`}</th>
                        </tr>
                    </thead>
                </DataTable>
            </div>
        </div>
    );

    return <>{bal} {stat} {trd}</>
}

export { Trade };